<template>
  <div class="address-sheet">
    <ClientOnly>
      <BlSheetMv
        title="Masukkan Alamat"
        :is-draggable="false"
        :active="isActive"
        @update:active="$emit('update:isActive', $event)"
      >
        <form
          slot="content"
          class="p-16"
          data-testid="form"
          @submit.prevent="addNewAddress"
        >
          <BlFieldMv
            label="Nama lengkap penerima"
            :message="{ error: validators.receiverName }"
            :error="!!validators.receiverName"
            data-testid="field-receiver-name"
          >
            <BlTextfieldAv
              v-model="form.receiverName"
              placeholder="Contoh: Caca Handika"
              data-testid="input-receiver-name"
            />
          </BlFieldMv>
          <BlFieldMv
            label="No. Handphone penerima"
            :message="{ error: validators.receiverPhone }"
            :error="!!validators.receiverPhone"
            data-testid="field-receiver-phone"
          >
            <BlTextfieldAv
              v-model="form.receiverPhone"
              placeholder="Masukkan nomor telepon penerima"
              data-testid="input-receiver-phone"
              type="tel"
            />
          </BlFieldMv>
          <BlFieldMv
            label="Provinsi"
            :message="{ error: validators.province }"
            :error="!!validators.province"
            data-testid="field-province"
          >
            <BlDropdownAv
              v-model="form.province"
              placeholder="Pilih provinsi"
              data-testid="input-province"
            >
              <option
                v-for="province in provinces"
                :key="province"
                :value="province"
              >
                {{ province }}
              </option>
            </BlDropdownAv>
          </BlFieldMv>
          <BlFieldMv
            label="Kota/Kabupaten"
            :message="{ error: validators.city }"
            :error="!!validators.city"
            data-testid="field-city"
          >
            <BlDropdownAv
              v-model="form.city"
              :placeholder="form.province ? 'Pilih kota/kabupaten' : ''"
              data-testid="input-city"
              :disabled="!form.province"
            >
              <option v-for="city in cities" :key="city" :value="city">
                {{ city }}
              </option>
            </BlDropdownAv>
          </BlFieldMv>
          <BlFieldMv
            label="Kecamatan"
            :message="{ error: validators.area }"
            :error="!!validators.area"
            data-testid="field-area"
          >
            <BlDropdownAv
              v-model="form.area"
              :placeholder="form.city ? 'Pilih kecamatan' : ''"
              data-testid="input-area"
              :disabled="!form.city"
            >
              <option v-for="area in areas" :key="area" :value="area">
                {{ area }}
              </option>
            </BlDropdownAv>
          </BlFieldMv>
          <BlFieldMv
            label="Kelurahan"
            :message="{ error: validators.district }"
            :error="!!validators.district"
            data-testid="field-district"
          >
            <BlDropdownAv
              v-model="form.district"
              :placeholder="form.area ? 'Pilih kelurahan' : ''"
              data-testid="input-district"
              :disabled="!form.area"
            >
              <option
                v-for="district in districts"
                :key="district"
                :value="district"
              >
                {{ district }}
              </option>
            </BlDropdownAv>
          </BlFieldMv>
          <BlFieldMv
            v-if="isPostalCodeRequired"
            label="Kode pos"
            :message="{ error: validators.postalCode }"
            :error="!!validators.postalCode"
            data-testid="field-postal-code"
          >
            <BlDropdownAv
              v-model="form.postalCode"
              :placeholder="form.district ? 'Pilih kode pos' : ''"
              data-testid="input-postal-code"
              :disabled="!form.district"
            >
              <option
                v-for="postalCode in postalCodes"
                :key="postalCode"
                :value="postalCode"
              >
                {{ postalCode }}
              </option>
            </BlDropdownAv>
          </BlFieldMv>
          <div class="grid grid-cols-2 gap-4">
            <BlFieldMv label="RT">
              <BlTextfieldAv
                v-model="form.rt"
                placeholder="Masukkan RT"
                data-testid="input-rt"
                @keypress="
                  e => {
                    if (!/^\d$/.test(e.key)) e.preventDefault();
                  }
                "
              />
            </BlFieldMv>
            <BlFieldMv label="RW">
              <BlTextfieldAv
                v-model="form.rw"
                placeholder="Masukkan RW"
                data-testid="input-rw"
                @keypress="
                  e => {
                    if (!/^\d$/.test(e.key)) e.preventDefault();
                  }
                "
              />
            </BlFieldMv>
          </div>
          <BlFieldMv
            label="Alamat"
            :message="{
              hint:
                'Isi alamat selengkap-lengkapnya untuk mempermudah proses pengiriman',
              error: validators.address,
            }"
            :error="!!validators.address"
            data-testid="field-address"
          >
            <BlTextareaAv
              v-model="form.address"
              placeholder="Masukkan alamat"
              data-testid="input-address"
            />
          </BlFieldMv>
          <BlFieldMv
            label="Nama alamat"
            :message="{ error: validators.title }"
            :error="!!validators.title"
            data-testid="field-title"
          >
            <BlTextfieldAv
              v-model="form.title"
              placeholder="Masukkan nama alamat"
              data-testid="input-title"
            />
          </BlFieldMv>
          <BlButtonAv fullwidth class="mt-12" type="submit">
            Submit
          </BlButtonAv>
        </form>
      </BlSheetMv>
    </ClientOnly>
  </div>
</template>

<script>
import {
  BlButtonAv,
  BlTextareaAv,
  BlTextfieldAv,
  BlDropdownAv,
  BlFieldMv,
  BlSheetMv,
} from '@bukalapak/bazaar-mweb';
import publicAddressApi from 'shared_js/api/publicApi/publicAddressApi';
import ClientOnly from 'vue-client-only';

const TRACKER_SCREEN_NAME = 'item-mitra-address-form-';

function initialForm() {
  return {
    receiverName: '',
    receiverPhone: '',
    province: null,
    city: null,
    area: null,
    district: null,
    postalCode: null,
    rt: '',
    rw: '',
    address: '',
    title: '',
  };
}

export default {
  name: 'AddressFormModal',
  components: {
    BlButtonAv,
    BlDropdownAv,
    BlFieldMv,
    BlTextareaAv,
    BlTextfieldAv,
    BlSheetMv,
    ClientOnly,
  },
  model: {
    prop: 'isActive',
    event: 'update:isActive',
  },
  props: {
    isActive: {
      type: Boolean,
      default: true,
    },
    mitraItemId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      provinces: [],
      cities: [],
      areas: [],
      districts: [],
      postalCodes: [],
      form: initialForm(),
      validators: Object.keys(initialForm()).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {}),
    };
  },
  computed: {
    isPostalCodeRequired() {
      return !!this.form.district && this.postalCodes.length > 0;
    },
  },
  watch: {
    isActive(newVal) {
      if (newVal) {
        this.visitScreenTrack();
      }
      this.form = initialForm();
    },
    form: {
      async handler() {
        this.validators = {};
      },
      deep: true,
    },
    'form.province': {
      handler(newVal, prevVal) {
        if (newVal && newVal !== prevVal) {
          this.cities = Object.keys(this.addresses[this.form.province]);
        }
      },
    },
    'form.city': {
      handler(newVal, prevVal) {
        if (newVal && newVal !== prevVal) {
          this.areas = this.addresses[this.form.province][this.form.city];
        }
      },
    },
    'form.area': {
      async handler(newVal, prevVal) {
        if (newVal && newVal !== prevVal) {
          await this.fetchDistricts();
        }
      },
    },
    'form.district': {
      async handler(newVal, prevVal) {
        if (newVal && newVal !== prevVal) {
          await this.fetchPostalCodes();
        }
      },
    },
  },
  async mounted() {
    await this.fetchAddresses();
  },
  methods: {
    async fetchAddresses() {
      try {
        const response = await publicAddressApi.retrieveAddresses();
        this.addresses = response.data;
        this.provinces = Object.keys(response.data);
      } catch (error) {
        this.$showNotificationFlash('Gagal mendapatkan data', 'error');
      }
    },
    async fetchDistricts() {
      try {
        const response = await publicAddressApi.retrieveSubdistricts(
          this.form.province,
          this.form.city,
          this.form.area,
        );
        this.districts = response.data;
      } catch (error) {
        this.$showNotificationFlash('Gagal mendapatkan data', 'error');
      }
    },
    async fetchPostalCodes() {
      try {
        const response = await publicAddressApi.retrievePostCodes(
          this.form.province,
          this.form.city,
          this.form.area,
        );
        this.postalCodes = response.data;
      } catch (error) {
        this.$showNotificationFlash('Gagal mendapatkan data', 'error');
      }
    },
    validate() {
      const phoneRegex = /^(0|\+?62)8\d{8,11}$/;
      this.validators = {
        receiverName: this.form.receiverName.trim()
          ? ''
          : 'Nama penerima wajib diisi',
        receiverPhone: !this.form.receiverPhone.trim()
          ? 'No. Handphone penerima wajib diisi'
          : phoneRegex.test(this.form.receiverPhone.trim())
          ? ''
          : 'Format tidak sesuai, mohon periksa kembali.',
        province: this.form.province ? '' : 'Provinsi wajib diisi',
        city: this.form.city ? '' : 'Kota/Kabupaten wajib diisi',
        area: this.form.area ? '' : 'Kecamatan wajib diisi',
        district: this.form.district ? '' : 'Kelurahan wajib diisi',
        postalCode:
          this.form.postalCode || !this.isPostalCodeRequired
            ? ''
            : 'Kode pos wajib diisi',
        address: this.form.address.trim() ? '' : 'Alamat wajib diisi',
        title: this.form.title ? '' : 'Nama alamat wajib diisi',
      };
      return Object.keys(this.validators).every(key => !this.validators[key]);
    },
    addNewAddress() {
      if (!this.validate()) return;
      this.trackAddressSubmit();
      this.$emit('submit', this.form);
      this.$emit('update:isActive', false);
    },
    trackAddressSubmit() {
      if (this.$tracker && this.mitraItemId) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-submit-address-form',
          current_screen: `${TRACKER_SCREEN_NAME}${this.mitraItemId}`,
          target_screen: 'address_form_modal',
        });
      }
    },
    visitScreenTrack() {
      if (this.$tracker && this.mitraItemId) {
        this.$tracker.itemMitraLandingPageVisitTrack({
          current_screen: `${TRACKER_SCREEN_NAME}${this.mitraItemId}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address-sheet {
  ::v-deep {
    .bl-sheet__box,
    .bl-sheet__nav-bar {
      border-radius: 0;
    }

    .bl-sheet .bl-sheet__content {
      margin-bottom: 0;
    }
  }
}
</style>
